export default __webpack_public_path__ + "static/media/carou1.3734bca8.jpg";